import { useCallback, useState } from 'react';
import toast from 'react-hot-toast';
import { getApiError } from '../api/client';

export interface FormSubmitOptions {
  successMessage?: string;
  errorMessage?: string;
  onSuccess?: () => void | Promise<void>;
}

/** Wraps async form submit with loading state and toast success/error feedback. */
export function useFormSubmit() {
  const [submitting, setSubmitting] = useState(false);

  const submit = useCallback(
    async (action: () => Promise<unknown>, options: FormSubmitOptions = {}): Promise<boolean> => {
      const { successMessage, errorMessage = 'Save failed', onSuccess } = options;
      setSubmitting(true);
      try {
        await action();
        if (successMessage) toast.success(successMessage);
        await onSuccess?.();
        return true;
      } catch (err) {
        toast.error(getApiError(err, errorMessage));
        return false;
      } finally {
        setSubmitting(false);
      }
    },
    []
  );

  return { submit, submitting };
}

export default useFormSubmit;
